import {
  GET_ADDITIONAL_CUSTOMER,
  GET_ADDITIONAL_CUSTOMER_FAILED,
  GET_ADDITIONAL_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAILED,
  GET_CUSTOMER_REQUIRED_DETAILS_SUCCESS,
  GET_CUSTOMER_SUCCESS,
} from './types';

import additionalCustomerReducer from './additionalCustomerReducer';

const initialState = {
  loaded: false,
  additionalCustomers: {},
};

const mergeRequiredDetails = (state, action) =>
  action.payload.requiredDetails.reduce((agg, cur) => {
    if (
      ['account_name', 'account_number', 'sort_code', 'iban_number'].includes(
        cur,
      ) &&
      !agg.includes('bank_account')
    ) {
      return [...agg, 'bank_account'];
    }

    return [...agg, cur];
  }, state);

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_SUCCESS:
      return {
        ...state,
        loaded: true,
        ...action.payload.customer,
      };
    case GET_CUSTOMER_FAILED:
      return {
        ...state,
        loaded: false,
      };
    case GET_CUSTOMER_REQUIRED_DETAILS_SUCCESS: {
      return {
        ...state,
        requiredDetails: mergeRequiredDetails([], action),
      };
    }
    case GET_ADDITIONAL_CUSTOMER:
    case GET_ADDITIONAL_CUSTOMER_SUCCESS:
    case GET_ADDITIONAL_CUSTOMER_FAILED:
      return {
        ...state,
        additionalCustomers: additionalCustomerReducer(
          state.additionalCustomers,
          action,
        ),
      };
    default:
      return state;
  }
};

export default customerReducer;
